<template>
    <div class="report">
      <div class="report-content">
        <router-view></router-view>
      </div>
      <img class="report-icon" src="../../../assets/content-box.png"/>
    </div>
</template>

<script>
export default {
  name: 'Report',
  data () {
    return {}
  }
}
</script>

<style scoped>
 @import "Report.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/report/Report.vue